<template>
  <div class="container-footer">
    <!-- 底部 -->
    <!-- <div class="footer">
      <div class="footer-left">
        <div class="footer-left-code">
          <img v-lazy="require('@/assets/footer-code.png')" alt="丰派收银" />
        </div>
        <div class="footer-left-word">
          <div>扫码关注公众号</div>
          <div>获取更多信息</div>
        </div>
      </div>
      <div class="footer-line"></div>
      <div class="footer-right">
        <div class="footer-right-tit">联系我们</div>
        <div class="footer-right-content">
          <div class="footer-right-item">
            <div class="footer-right-item-icon">
              <img v-lazy="require('@/assets/call.png')" alt="丰派收银" />
            </div>
            <div class="footer-right-item-tit">联系电话：</div>
            <div class="footer-right-item-content">400-086-1123</div>
          </div>
          <div class="footer-right-item">
            <div class="footer-right-item-icon">
              <img v-lazy="require('@/assets/clock.png')" alt="丰派收银" />
            </div>
            <div class="footer-right-item-tit">工作时间：</div>
            <div class="footer-right-item-content">周一至周五 9：00-21：00</div>
          </div>
          <div class="footer-right-item">
            <div class="footer-right-item-icon">
              <img v-lazy="require('@/assets/location.png')" alt="丰派收银" />
            </div>
            <div class="footer-right-item-tit">公司地址：</div>
            <div class="footer-right-item-content">
              东莞市长安镇泰宝商厦三层
            </div>
          </div>
        </div>
        <div class="footer-right-bottom">
          Copyright@ 2021 东莞市丰派软件科技有限公司<a
            href="https://beian.miit.gov.cn/#/Integrated/index"
            >粤ICP备19023742号</a
          ><a
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44190002006124"
            class="gongan"
          >
            <img
              v-lazy="require('@/assets/gongan.png')"
              alt="丰派收银"
            />粤公网安备4419000206124号</a
          >
        </div>
      </div>
    </div> -->
    <div class="footer-top">
      <div class="top-box">
        <div class="box1">
          <img class="foot-img1" v-lazy="require('@/assets/cs1.png')" alt="" />
          <img
            class="foot-img2"
            v-lazy="require('@/assets/foot2.png')"
            alt=""
          />
          <div class="box-text">
            <div class="text">关注公众号</div>
            <div class="text">了解更多信息</div>
          </div>
        </div>
        <div class="box2">
          <div class="text1">产品介绍</div>
          <div class="text2-box">
            <div class="text2" @click="toTop">丰派云POS</div>
            <div class="text2" @click.stop="go(2)">智慧零售</div>
            <div class="text2" @click.stop="go(3)">订货平台</div>
            <div class="text2" @click.stop="go(1)">管理后台</div>
          </div>
        </div>
        <div class="box2">
          <div class="text1">解决方案</div>
          <div class="text2-box">
            <div class="text2">互联网</div>
            <div class="text2">媒体</div>
            <div class="text2">人力资源</div>
            <div class="text2">销售</div>
          </div>
        </div>
        <div class="box2 box3">
          <div class="text1">帮助和支持</div>
          <div class="text2-box">
            <div class="text2">帮助中心</div>
            <div class="text2">应用目录</div>
            <div class="text2">合作伙伴</div>
            <div class="text2">更新日志</div>
          </div>
        </div>
        <div class="box4">
          <div class="text1">联系我们</div>
          <div class="text2-box">
            <div class="text2">
              <img
                v-lazy="require('@/assets/call1.png')"
                alt=""
                class="img-f"
              />
              <span class="span1">联系电话：</span>
              <span class="span2">400-086-1123</span>
            </div>
            <div class="text2">
              <img
                v-lazy="require('@/assets/clock1.png')"
                alt=""
                class="img-f"
              />
              <span class="span1">工作时间：</span
              ><span class="span2">周一至周五 9：00-21：00</span>
            </div>
            <div class="text2">
              <img v-lazy="require('@/assets/dw.png')" alt="" class="img-f" />
              <span class="span1">公司地址：</span
              ><span class="span2">东莞市长安镇泰宝商厦三层</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-bottom">
      <div class="bottom-text1">
        Copyright © 2020 — 2024 东莞市丰派软件科技有限公司
      </div>
      <div @click="openHred" class="bottom-text1 bottom-text2">
        粤ICP备19023742号-2
      </div>
      <div @click="openHred1" class="gongan-box">
        <img v-lazy="require('@/assets/gongan.png')" class="gongan" alt="" />
        <span class="bottom-text1">粤公网安备44190002006124号</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ifooter",
  methods: {
    toTop() {

      let top = document.documentElement.scrollTop || document.body.scrollTop;
      // 实现滚动效果
      const timeTop = setInterval(() => {
        document.body.scrollTop = document.documentElement.scrollTop = top -= 50;
        if (top <= 0) {
          clearInterval(timeTop);
        }
      }, 10);
    },
    openHred() {
      window.open("https://beian.miit.gov.cn/#/Integrated/index");
    },
    openHred1() {
      window.open(
        "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44190002006124"
      );
    },
    go(index) {
      if (index == 1) {
        location.href = "https://www.fp1123.com/fpPos/#/login";
      } else if (index == 2) {
        // location.href = "https://gb.fp1123.com/#/login";
        window.open("https://gb.fp1123.com/");
      } else {
        // location.href = "https://db.fp1123.com/admin/#/login";
        window.open("https://db.fp1123.com/admin/");
      }
    },
  },
};
</script>
<style lang="less" scoped>
.container-footer {
  width: 100%;
  min-width: 1420px;
  position: relative;
  margin-top: 60px;
}
.footer-top {
  width: 100%;
  height: 286px;
  background: linear-gradient(0deg, #ffffff, #ffffff), #f6f7fb;
  padding: 60px 0 40px;
  .top-box {
    margin: 0 auto;
    width: 1014px;
    display: flex;
    justify-content: space-between;
    align-content: center;
    .box1 {
      width: 100px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .foot-img1 {
        height: 40px;
      }
      .foot-img2 {
        width: 100px;
        height: 100px;
      }
      .box-text {
        text-align: center;
        .text {
          color: #253554;
          font-size: 12px;
          line-height: 20px;
        }
      }
    }
    .box2 {
      width: 80px;
      .text1 {
        text-align: center;
        font-size: 19px;
        line-height: 28px;
        margin-bottom: 16px;
        color: #51565d;
      }
      .text2-box {
        .text2 {
          font-size: 13px;
          line-height: 30px;
          color: #1f2329;
          cursor: pointer;
        }
      }
    }
    .box3 {
      width: 100px;
    }
    .box4 {
      width: 258px;
      .text1 {
        font-size: 19px;
        line-height: 28px;
        margin-bottom: 16px;
        color: #51565d;
      }
      .text2-box {
        .text2 {
          height: 30px;
          display: flex;
          align-items: center;
          cursor: pointer;
          .img-f {
            width: 16px;
            height: 16px;
          }
          .span1 {
            width: 68px;
            font-size: 13px;
            line-height: 30px;
            color: #1f2329;
          }
          .span2 {
            font-size: 13px;
            line-height: 30px;
            color: #1f2329;
          }
        }
      }
    }
  }
}
.footer-bottom {
  width: 100%;
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f6f7;
  .bottom-text1 {
    font-size: 12px;
    color: #3d485d;
    line-height: 22px;
    margin-right: 20px;
  }
  .bottom-text2 {
    cursor: pointer;
  }
  .gongan-box {
    cursor: pointer;
    display: flex;
    align-items: center;
    .gongan {
      width: 14px;
      height: 14px;
      margin-right: 4px;
    }
  }
}
.footer {
  width: 1200px;
  height: 310px;
  display: flex;
  //   align-items: center;
  justify-content: center;
  background: #172033;
  .footer-left {
    margin-top: 52px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .footer-left-code {
      width: 129px;
      height: 129px;
      overflow: hidden;
      img {
        width: 129px;
        height: 129px;
      }
    }
    .footer-left-word {
      margin-top: 17px;
      width: 112px;
      height: 60px;
      font-weight: 350;
      font-size: 16px;
      color: #ffffff;
      div {
        text-align: center;
      }
    }
  }
  .footer-line {
    margin-top: 55px;
    margin-left: 149px;
    margin-right: 148px;
    width: 1px;
    height: 200px;
    background: #c4c4c4;
  }
  .footer-right {
    margin-top: 44px;
    .footer-right-tit {
      font-weight: 500;
      font-size: 30px;
      color: #ffffff;
    }
    .footer-right-content {
      margin-top: 20px;
      width: 373px;
      height: 127px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      .footer-right-item {
        display: flex;
        .footer-right-item-icon {
          margin-right: 13px;
          width: 20px;
          height: 20px;
          //   overflow: hidden;
          img {
            width: 20px;
            height: 20px;
          }
        }
        .footer-right-item-tit {
          font-weight: 350;
          font-size: 16px;
          color: #ffffff;
        }
        .footer-right-item-content {
          margin-left: 20px;
          font-weight: 350;
          font-size: 16px;
          color: #ffffff;
        }
      }
    }
    .footer-right-bottom {
      margin-top: 17px;
      font-weight: 350;
      font-size: 16px;
      color: #ffffff;
      display: flex;
      flex-wrap: nowrap;
      align-items: center;
      a {
        color: #fff;
        margin-left: 20px;
      }
      .gongan {
        display: flex;
        align-items: center;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pc/footer.vue